<template>
    <div class="studip-loading-skeleton"></div>
</template>

<script>
export default {
    name: 'StudipLoadingSkeleton'
}
</script>
